// extracted by mini-css-extract-plugin
export default {"dialog-modal":"Dialog_dialog-modal__-wr2k","dialog-pager":"Dialog_dialog-pager__nm9Ls"};